import { VendorExclusion } from '@/types/rollup'
import useCreateDetail, {
  UseCreateDetailOptions,
} from '../core-hooks/useCreateDetail'
import useDeleteDetail, {
  UseDeleteDetailOptions,
} from '../core-hooks/useDeleteDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import useUpdateList, {
  UseUpdateListOptions,
} from '../core-hooks/useUpdateList'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<VendorExclusion>({
  pathCategory: 'vendor_exclusions',
})

export function useGetVendorExclusions({
  filters,
  ...options
}: UseGetListOptions<VendorExclusion> = {}) {
  const query = useGetList<VendorExclusion>({
    filters,
    queryKey: queryKeys.vendorExclusions.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    vendorExclusions: query.allData,
    ...query,
  }
}

export function useCreateVendorExclusion(
  options: UseCreateDetailOptions<VendorExclusion> = {},
) {
  const mutation = useCreateDetail<VendorExclusion>({
    serviceFn: service.createDetail,
    ...options,
  })

  return {
    createVendorExclusion: mutation.mutate,
    createVendorExclusionAsync: mutation.mutateAsync,
    ...mutation,
  }
}

export function useUpdateVendorExclusions(
  options: UseUpdateListOptions<VendorExclusion> = {},
) {
  const mutation = useUpdateList<VendorExclusion>({
    serviceFn: service.updateList,
    ...options,
  })

  return {
    updateVendorExclusions: mutation.mutate,
    updateVendorExclusionsAsync: mutation.mutateAsync,
    ...mutation,
  }
}

export function useDeleteVendorExclusion(options: UseDeleteDetailOptions = {}) {
  const mutation = useDeleteDetail<VendorExclusion>({
    serviceFn: service.deleteDetail,
    ...options,
  })

  return {
    deleteVendorExclusion: mutation.mutate,
    deleteVendorExclusionAsync: mutation.mutateAsync,
    ...mutation,
  }
}
